import { ConnectPayments } from '@stripe/react-connect-js'
import { STRIPE_CONNECT_DASHBOARDLESS_SECTIONS } from '@/components/stripe-connect/stripeConnectSurfaceContent'
import { createFileRoute } from '@tanstack/react-router'
import { CreditCard } from 'lucide-react'
import { DashboardlessStripePage, dashboardlessStripeRouteLoader } from './-dashboardless-page'

const section = STRIPE_CONNECT_DASHBOARDLESS_SECTIONS.payments

export const Route = createFileRoute('/_authenticated/$orgId/settings/stripe/payments')({
  component: StripePaymentsPage,
  loader: dashboardlessStripeRouteLoader,
})

export function StripePaymentsPage() {
  return (
    <DashboardlessStripePage
      {...section}
      icon={CreditCard}
      sections={[{ ...section, component: ConnectPayments }]}
      surface="payments"
    />
  )
}
